__turbopack_context__.v({
  "container": "view-module__ahCuRG__container",
  "feed": "view-module__ahCuRG__feed",
  "feedContainer": "view-module__ahCuRG__feedContainer",
  "feedWithSlider": "view-module__ahCuRG__feedWithSlider",
  "newsFeedContentGap": "view-module__ahCuRG__newsFeedContentGap",
  "newsfeedArticle": "view-module__ahCuRG__newsfeedArticle",
  "tagFilterContainer": "view-module__ahCuRG__tagFilterContainer",
  "tagFilterWrapper": "view-module__ahCuRG__tagFilterWrapper" + " " + __turbopack_context__.i(443839)["articleStandard"],
});
